import { Component, Input } from '@angular/core';
import { IconComponent } from './icon.component';
import { TagComponent } from './tag.component';

@Component({
  selector: 'app-include-label',
  template: ` <div class="tw-flex tw-flex-col tw-items-end tw-gap-2">
    @for (label of include; track label) {
      <app-tag type="Success">
        <div class="tw-flex tw-gap-2 tw-py-0.5">
          <app-icon name="fa-light fa-check" />
          <div>{{ label }}</div>
        </div>
      </app-tag>
    }
    @for (label of exclude; track label) {
      <app-tag type="Error">
        <div class="tw-flex tw-gap-2 tw-py-0.5">
          <app-icon name="fa-light fa-xmark" />
          <div>{{ label }}</div>
        </div>
      </app-tag>
    }
  </div>`,
  styles: [],
  imports: [IconComponent, TagComponent],
})
export class IncludeLabelComponent {
  @Input()
  include: string[] = [];

  @Input()
  exclude: string[] = [];
}
